import React from "react";
import PropTypes from "prop-types";
import "./Tooltip.scss";

const Tooltip = ({ children, content, position = "top", className = "" }) => {
  return (
    <div
      data-tooltip={content}
      data-position={position}
      className={`tw-inline-flex tw-items-center ${className}`}
    >
      {children}
    </div>
  );
};

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  content: PropTypes.string.isRequired,
  position: PropTypes.oneOf(["top", "right"]),
  className: PropTypes.string,
};

export default Tooltip;
